module.exports = __webpack_public_path__ + "img/Card.3d17b166.svg";